import mixin from "../mixin"

export default {
  mixins: [mixin],
  props: {
    vm: {
      type: Object
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BlastStudent/sidebar/sidebar.js